import { jsxs as y, jsx as r } from "react/jsx-runtime";
import S from "../LetsGoTouringModal/LetsGoTouringModal.js";
import G from "../UnitCard/UnitCard.js";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import l from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import M from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import N from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import "@propify-tenant-client/common";
import { getSdkUnitListClassName as a } from "../../utils/sdk.js";
import T from "classnames";
import { useState as b } from "react";
const C = M({
  card: {
    display: "flex",
    justifyContent: "center",
    scrollMarginTop: "60px"
  },
  selected: {
    padding: "0.05em",
    background: "rgba(52,137,255,0.8)",
    borderRadius: "4px"
  }
}), k = ({
  classes: i,
  grid: c,
  selectionEnabled: m = !1,
  maxDisplay: u = Number.MAX_SAFE_INTEGER,
  units: f = [],
  activePlace: o,
  setActivePlace: g,
  onRegisterSubmit: x,
  onLoginSubmit: L,
  onScheduleShowingStart: U
}) => {
  const [p, e] = b(), s = o == null ? void 0 : o.index, h = (t) => {
    g(s === t ? void 0 : { index: t, source: "unit-list" });
  };
  return /* @__PURE__ */ y(l, { className: a("unit-cards-container"), container: c, children: [
    f.slice(0, u).map((t) => {
      const n = m && s === t.id;
      return /* @__PURE__ */ r(
        l,
        {
          item: !0,
          ref: n ? (d) => {
            d && d.scrollIntoView({
              behavior: "smooth",
              block: "nearest"
            });
          } : null,
          xs: 12,
          sm: 12,
          md: 12,
          onClick: () => m && h(t.id),
          className: T(i.card, a("unit-card-wrapper"), {
            [i.selected]: n
          }),
          children: /* @__PURE__ */ r(
            G,
            {
              unit: t,
              onLetsGoTouringModalOpen: () => {
                U(), e(t);
              }
            }
          )
        },
        t.id
      );
    }),
    p ? /* @__PURE__ */ r(
      S,
      {
        open: !0,
        onClose: () => e(void 0),
        unit: p,
        onLoginSubmit: L,
        onRegisterSubmit: x
      }
    ) : null
  ] });
}, Ft = N(C, { name: "UnitList" })(k);
export {
  Ft as default
};
//# sourceMappingURL=UnitList.js.map
